var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 16" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M10 5.1l-1-1-5.1 5c-.7 1-.5 2.3.5 3 .7.5 1.8.5 2.5 0L13 6c1.3-1.5 1.2-3.7-.3-5.1a3.65 3.65 0 0 0-4.8 0L1.6 7.4c-2 2-2 5.1 0 7.1s5.1 2 7.1 0l4.4-4.4-1-1-4.4 4.4c-1.6 1.2-3.8.9-5-.7-1-1.3-1-3 0-4.3L9 2.1c1-.7 2.3-.5 3 .5.5.7.5 1.8 0 2.5l-6.1 6.1c-.3.2-.8.1-1-.2-.2-.2-.2-.6 0-.8L10 5.1z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Attachment.svg